import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import { Button, Spinner } from "react-bootstrap";
import Card from "src/components/Cards/Basic";
import FormCheckbox from "src/components/Forms/FormCheckbox";
import FormSelectBox from "src/components/Forms/FormSelectBox";
import {
  showSuccessToast,
  showValidationErrorToast,
} from "src/components/Toasts";
import axios from "src/config/axios";
import { useTranslation } from "react-i18next";
import FormInputText from "src/components/Forms/FormInputText";

const GeneralSettingsPage = () => {
  const [businessSetting, setBusinessSetting] = useState();
  const { t } = useTranslation("dashboard");

  useEffect(() => {
    axios.get("/api/v1/business_setting.json").then(({ data }) => {
      setBusinessSetting(data);
    });
  }, []);

  function handleSubmit(values, helpers) {
    helpers.setSubmitting(true);
    axios
      .put("/api/v1/business_setting.json", { business_setting: values })
      .then(({ data }) => {
        setBusinessSetting(data);
        showSuccessToast();
      })
      .catch((error) => {
        helpers.setErrors(error.response.data);
        showValidationErrorToast(error);
      })
      .finally(() => {
        helpers.setSubmitting(false);
      });
  }

  const overdueOptions = [
    { value: 1, name: "1" },
    { value: 2, name: "2" },
    { value: 3, name: "3" },
    { value: 4, name: "4" },
    { value: 5, name: "5" },
    { value: 6, name: "6" },
    { value: 7, name: "7" },
  ];

  return (
    <Card title={t("settings.business.general.title")}>
      {!businessSetting ? (
        <Spinner
          className={"d-block mx-auto"}
          animation="border"
          variant="primary"
        />
      ) : (
        <Formik
          initialValues={{
            smart_checkout_enabled:
              businessSetting.smart_checkout_enabled ?? false,
            smart_checkout_overdue_days:
              businessSetting.smart_checkout_overdue_days ?? 2,
            pay_local_tax_upfront_enabled:
              businessSetting.pay_local_tax_upfront_enabled,
            dogs_enabled: businessSetting.dogs_enabled ?? false,
            free_entry_period_minutes:
              businessSetting.free_entry_period_minutes ?? 15,
            max_stay_days: businessSetting.max_stay_days ?? 30,
          }}
          enableReinitialize={true}
          onSubmit={handleSubmit}
        >
          {({ values, isSubmitting }) => (
            <Form style={{ maxWidth: "900px" }}>
              <FormCheckbox
                name={"smart_checkout_enabled"}
                label={t("settings.business.smart_checkout.enabled.label")}
                hint={t("settings.business.smart_checkout.enabled.hint")}
              />

              {values.smart_checkout_enabled && (
                <FormSelectBox
                  name={"smart_checkout_overdue_days"}
                  label={t(
                    "settings.business.smart_checkout.overdue_days.label"
                  )}
                  hint={t("settings.business.smart_checkout.overdue_days.hint")}
                  options={overdueOptions}
                />
              )}

              <FormCheckbox
                name={"pay_local_tax_upfront_enabled"}
                label={t("settings.business.local_tax.upfront_enabled.label")}
                hint={t("settings.business.local_tax.upfront_enabled.hint")}
              />

              <FormCheckbox
                name={"dogs_enabled"}
                label={t("settings.business.dogs.enabled.label")}
              />

              <FormInputText
                name="free_entry_period_minutes"
                type="number"
                min={0}
                max={180}
                step={1}
                label={t("settings.business.free_entry_period_minutes.label")}
                hint={t("settings.business.free_entry_period_minutes.hint")}
              />

              <FormInputText
                name="max_stay_days"
                type="number"
                min={1}
                max={30}
                step={1}
                label={t("settings.business.max_stay_days.label")}
              />

              <Button type={"submit"} disabled={isSubmitting}>
                {t("common:components.button.save")}
              </Button>
            </Form>
          )}
        </Formik>
      )}
    </Card>
  );
};

export default GeneralSettingsPage;
